<template>
    <div ref="boxRef" class="job-container">
        <VJoyListItem
            :icon="icon"
            class="joy-mb-2"
            :class="{'not-clickable': buttonState !== 'NOTSTARTED'}"
            @click="buttonState === 'NOTSTARTED' && emit('start')"
        >
            <template #list-item-left>{{ t(title) }}</template>
            <template #list-item-right>
                <VJoyBadge
                    v-if="buttonState === 'DONE'"
                    :label="t(`client.onboarding.checklist.path.${buttonState}`)"
                    :data-testid="`${dataTestid}-${buttonState}`"
                    :bulletpoint="true"
                    variant="green"
                />
                <VJoyButton
                    v-else-if="buttonState === 'ONGOING'"
                    :label="t(`client.onboarding.checklist.path.${buttonState}`)"
                    :data-testid="`${dataTestid}-${buttonState}`"
                    variant="ghost"
                    size="xxsmall"
                />
                <VJoyButton
                    v-else
                    :label="t(`client.onboarding.checklist.path.${buttonState}`)"
                    :data-testid="`${dataTestid}-${buttonState}`"
                    variant="main"
                    size="xxsmall"
                />
            </template>
        </VJoyListItem>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {onMounted, useTranslation} from '#imports';
    import {launchConfetti} from '@malt/vue-animation';
    import {VJoyBadge, VJoyButton, VJoyListItem} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';
    import type {ClientOnboardingJobs} from '../openapi';
    import type {ShallowTranslationKey} from '#build/i18n';

    const props = defineProps<{
        icon: JoyIconsId;
        title: ShallowTranslationKey;
        buttonState: 'NOTSTARTED' | 'ONGOING' | 'DONE';
        dataTestid: string;
        jobJustFinished: keyof ClientOnboardingJobs | null;
        job: keyof ClientOnboardingJobs;
        redirectUrl?: string;
    }>();

    const emit = defineEmits(['start', 'confetti-animation-triggered']);

    const {t} = useTranslation();

    const boxRef = ref<HTMLDivElement>();

    onMounted(() => {
        if (props.jobJustFinished === props.job && boxRef.value) {
            launchConfetti(boxRef.value, {
                confettiOptions: {
                    particleCount: 300,
                    spread: 80,
                    origin: {y: 2.5},
                    startVelocity: 30,
                },
            });
            emit('confetti-animation-triggered');
        }
    });
</script>

<style lang="scss" scoped>
    .not-clickable {
        pointer-events: none;
    }

    /* .job-container {
        &--widthMargin {
            margin-top: calc(-1 * var(--joy-core-spacing-3));
        }

        &-tag {
            top: var(--joy-core-spacing-3);
            left: var(--joy-core-spacing-2);
        }
    } */
</style>
